"use client";

import { c as _c } from "react/compiler-runtime";
export function ExploreWaveCardSkeleton() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-aspect-[20/9] tw-animate-pulse tw-bg-iron-900" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-h-5 tw-w-3/4 tw-animate-pulse tw-rounded tw-bg-iron-800 sm:tw-h-6" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-overflow-hidden tw-rounded-xl tw-bg-iron-950 tw-ring-1 tw-ring-inset tw-ring-white/10">{t0}<div className="tw-px-4 tw-py-6 sm:tw-p-5">{t1}<div className="tw-mt-2 tw-space-y-2"><div className="tw-h-3 tw-w-full tw-animate-pulse tw-rounded tw-bg-iron-800/60" /><div className="tw-h-3 tw-w-5/6 tw-animate-pulse tw-rounded tw-bg-iron-800/60" /></div><div className="tw-mt-5 tw-h-4 tw-w-1/2 tw-animate-pulse tw-rounded tw-bg-iron-800/60" /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}